import { pad } from './numbers';

const formatDigit = (t, round = false) => {
  t = round ? Math.round(t) : Math.floor(t);
  return pad(t, 2);
};

export const getTimeFragment = (
  seconds,
  { floorSeconds = false, showMilliseconds = false } = {},
) => {
  const roundSeconds = !showMilliseconds && !floorSeconds;
  const s = formatDigit(seconds % 60, roundSeconds);
  const m = formatDigit((seconds % 3600) / 60);
  const hours = seconds / 3600;
  const H = Math.round(hours) > 0 ? `${formatDigit(hours)}:` : '';

  let msLabel = '';
  if (showMilliseconds) {
    const fixedNumber = seconds.toFixed(3);
    const ms = fixedNumber.substr(fixedNumber.indexOf('.') + 1);
    msLabel = `.${ms}`;
  }

  return `${H}${m}:${s}${msLabel}`;
};

export const formatSeconds = (seconds, decimal = 1) => {
  const fixedDecimalSeconds = seconds.toFixed(decimal);
  return seconds % 1 === 0 || fixedDecimalSeconds % 1 === 0
    ? seconds.toFixed(0)
    : fixedDecimalSeconds;
};
